module.exports = require("./dist/angular-spinners.min.js");


/*****************
 ** WEBPACK FOOTER
 ** angular-spinners (bower component)
 ** module id = 373
 ** module chunks = 1
 **/